import { styled } from 'leva/plugin';

export const StyledPanelLock = styled('div', {
  display: 'flex', 
  justifyContent: 'space-around',
  marginLeft: 'auto',
  marginRight: '0',
  fontSize: 'large',
  color: 'white',
  '&:hover': {
    color: 'red',
  },
});
